import { render } from "./IconTrashOutline.vue?vue&type=template&id=44bdf8ce"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconTrashOutline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44bdf8ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44bdf8ce', __exports__)) {
    api.reload('44bdf8ce', __exports__)
  }
  
  module.hot.accept("./IconTrashOutline.vue?vue&type=template&id=44bdf8ce", () => {
    api.rerender('44bdf8ce', render)
  })

}


export default __exports__